import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Заглушка для типов расчета, которые пока не выводим
 */
export const HistoryItemStub = () => {
  const { t } = useTranslation('OrderList');

  return (
    <div className={'order-product-component'}>
      <Typography variant={'h4'}>{t('OrderList:CalculationTypeNotSupported')}</Typography>
    </div>
  );
};
